import { ModuleWithProviders, NgModule } from '@angular/core';

import { ThemeConfigService } from './theme.config.service';
import { THEME_CONFIG } from './theme.config.types';

@NgModule()
export class ThemeConfigModule {
	constructor(private _ThemeConfigService: ThemeConfigService) {}
	static forRoot(config: any): ModuleWithProviders<ThemeConfigModule> {
		return {
			ngModule: ThemeConfigModule,
			providers: [
				{
					provide: THEME_CONFIG,
					useValue: config,
				},
			],
		};
	}
}
